import { Shirt, Camera, ClipboardCheck, Trophy, Droplets } from "lucide-react";
import { INCLUDED, BRING } from "@/data/content";
import { Reveal, SectionHead } from "@/components/site/Reveal";

const ICONS = [Trophy, Shirt, Camera, ClipboardCheck];

export const Included = () => (
  <section data-testid="included-section" className="relative">
    <div className="section">
      <SectionHead eyebrow="What's Included" testid="included-title" title={<>Every player<br />receives</>} />
      <div className="grid grid-cols-1 md:grid-cols-6 gap-4">
        {INCLUDED.map((it, i) => {
          const Icon = ICONS[i];
          const span = it.big ? "md:col-span-4 md:row-span-2 min-h-[320px]" : "md:col-span-2";
          return (
            <Reveal key={it.t} delay={i * 0.06} className={`${span} relative overflow-hidden rounded-3xl border border-white/10 bg-white/[0.03] p-7 md:p-8 group hover:border-[var(--accent)]/40 transition-colors`}>
              {it.big && <img src="/images/ball.jpg" alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-35 group-hover:opacity-50 group-hover:scale-105 transition-[opacity,transform] duration-700" />}
              {it.big && <div className="absolute inset-0 bg-gradient-to-t from-[#070a11] via-[#070a11]/60 to-transparent" />}
              <div className={`relative h-full flex flex-col ${it.big ? "justify-end" : ""}`} data-testid={`included-item-${i}`}>
                <Icon size={it.big ? 34 : 24} className="accent-text" strokeWidth={1.5} />
                <h3 className={`mt-6 font-display font-bold tracking-tight ${it.big ? "text-4xl md:text-5xl" : "text-2xl"}`}>{it.t}</h3>
                <p className="mt-3 text-sm text-slate-400 leading-relaxed max-w-md">{it.d}</p>
              </div>
            </Reveal>
          );
        })}
        <Reveal delay={0.3} className="md:col-span-2 rounded-3xl border border-dashed border-white/15 p-7 md:p-8">
          <div data-testid="included-bring">
            <Droplets size={24} className="text-slate-300" strokeWidth={1.5} />
            <h3 className="mt-6 font-display font-bold tracking-tight text-2xl">Players bring</h3>
            <p className="mt-3 text-sm text-slate-400 leading-relaxed">{BRING}</p>
          </div>
        </Reveal>
      </div>
      <p className="mt-10 font-display text-xl tracking-tight" data-testid="included-price">
        Total investment: <span className="accent-text font-bold">$549 AUD</span> <span className="text-slate-500 text-base">including GST · Stripe transaction fee already deducted · $61 per day over 9 days</span>
      </p>
    </div>
  </section>
);
